import { useEffect } from 'react';

import { MobileHeaderConfig, useNavigationContext } from '../contexts/NavigationContext';

/**
 * Hook for detail pages to replace the default mobile AppBar with a simple header.
 *
 * Automatically cleans up on unmount to restore default navigation.
 *
 * @example
 * // In a detail page component
 * function JobDetailsPage() {
 *   useSetMobileHeader({
 *     title: t('jobDetails'),
 *     backUrl: APP_ROUTES.myJobs
 *   });
 *
 *   return <PageContentCard>...</PageContentCard>;
 * }
 */
export function useSetMobileHeader(config: MobileHeaderConfig) {
    const { setMobileHeaderOverride } = useNavigationContext();
    const { title, backUrl, showUserWidget, isLoading } = config;

    useEffect(() => {
        setMobileHeaderOverride({ title, backUrl, showUserWidget, isLoading });

        return () => {
            setMobileHeaderOverride(null);
        };
    }, [ setMobileHeaderOverride, title, backUrl, showUserWidget, isLoading ]);
}
